import { Component, Input } from '@angular/core';
import { InspectionValueCase } from '@authority-labs/api-interfaces';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-basic-select-case',
  templateUrl: './check-basic-select-case.component.html',
  styleUrls: ['./check-basic-select-case.component.scss']
})
export class CheckBasicSelectCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: InspectionValueCase;
  @Input() options: string[];
}
